import { useSelector } from "react-redux";

export const HasPermission = (
  permissionName: string,
  permissionAccessName: string
) => {
  const userPermissions = useSelector(
    (state: any) => state.userPermisssion.UserPermissions
  );
  const keyMapping: any = {
    CREATE: "Create_Flg",
    UPDATE: "Update_Flg",
    READ: "Read_Flg",
    DELETE: "SoftDelete_Flg",
  };
  const permissionIndex = userPermissions?.findIndex(
    (item: any) => item.Permissions_Nm === permissionName
  );
  const permissionAccessNm = keyMapping[permissionAccessName];
  return (userPermissions)?(userPermissions[permissionIndex][permissionAccessNm] === "Y"
    ? true
    : false)
    :false;
};

//  * @param {String} moduleName - e.g. "Business Units"
//  * @param {Boolean} isModule - true => Module, false => Feature
//  * @param {String} action - "create" | "read" | "update" | "delete"
//  * @returns {Boolean}
export function checkRolePermissions(moduleName: string, isModule: boolean, action: string) {
   
   const storedData = localStorage.getItem("permissionsData");
   const permissions = storedData ? JSON.parse(storedData) : [];

    if (!Array.isArray(permissions)) return false;

    const actionMap: any = {
        create: "Create_Flg",
        read: "Read_Flg",
        update: "Update_Flg",
        delete: "SoftDelete_Flg"
    };

    const field = actionMap[action]; // no lowercase handling
    if (!field) return false;

    const type = isModule ? "Module" : "Feature";

    return permissions
        .filter(
            item =>
                item.SystemAdminPermissions_Nm === moduleName &&
                item.Permission_Typ === type
        )
        .some((item:any) => item[field] === "Y");
}
